// extracted by mini-css-extract-plugin
export var infoItem = "_sx-2";
export var title = "_sx-0";
export var value = "_sx-1";